module.exports = __webpack_public_path__ + "3eb486c0175898e05f92e9980de2adb6.png";